module.exports = "/lucky-balls/img/drum/drum_loop_020.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_020.png
// module id = 1035
// module chunks = 0